var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Center, Heading, Link, Text } from "@reverb-ui/react";
import OhDang from "@/assets/images/oh-dang-error.svg";
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error.message);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (React.createElement(Center, { pt: 12, w: "full", flexDirection: "column" },
                React.createElement(OhDang, null),
                React.createElement(Heading, { fontWeight: "semibold", pb: 4, color: "gray.900", fontSize: "2xl" }, "Oh dang!"),
                React.createElement(Text, { maxW: "400px", textAlign: "center", color: "gray.500" },
                    React.createElement(Text, null, "This page doesn\u2019t seem to be answering."),
                    React.createElement(Text, null,
                        "Try refreshing it in a few instants. If it doesn\u2019t respond, you can contact",
                        " ",
                        React.createElement(Link, { color: "blue.500", textDecor: "underline", href: "https://wiki.rockcontent.com/doc/os-request-supportassistance-dg6wIm9Sp2", target: "_blank" }, "our support.")))));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
